import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { BlobService, N2BlobReference } from "@shared/pdf-viewer/blob.service";

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then((appRef) => {
    BlobService(new N2BlobReference());
  })
  .catch((err) => console.error(err));
